import { render, staticRenderFns } from "./NewOrderSendConfirm.vue?vue&type=template&id=5be37d04&"
import script from "./NewOrderSendConfirm.vue?vue&type=script&lang=js&"
export * from "./NewOrderSendConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports